import { YD_COURSE_APP_API_SUPPORT_VERSION_LIST } from 'util/constants'

export function num2likestr(num: number) {
  if (num >= 10000) {
    num = num / 10000
    return stripDot0(num.toFixed(1)) + '万'
  }
  if (num >= 1000) {
    num = num / 1000
    return stripDot0(num.toFixed(1)) + '千'
  }
  return String(num||0)
}

export function stripDot0(str: string) {
  if (str.endsWith('.0')) {
    return str.slice(0, str.length - 2)
  }
  return str
}

export function arrGroup<T>(arr: T[], sublen: number): T[][] {
  const ret: T[][] = []
  let cur: T[] = []
  let count = 0
  if (count === sublen) {
    throw new Error('死循环提前退出')
  }

  const flush = () => {
    count = 0
    ret.push(cur)
    cur = []
  }
  for (let i = 0; i < arr.length; i++) {
    if (count === sublen) {
      flush()
    }
    cur.push(arr[i])
    count++
  }
  if (count) {
    flush()
  }
  return ret
}

export function doTimes<T>(start: number, times: number, fn: (i: number) => T): T[] {
  const ret = []
  while (times > 0) {
    --times
    ret.push(fn(start++))
  }
  return ret
}

export function forkNumToText(isFork: number) {
  if (isFork === 0) {
    return ''
  }
  if (isFork == 1) {
    return '原创'
  }
  if (isFork == 2) {
    return '改编'
  }
}

export function enhancedEventKeRlog(
  eventVal: string,
  addition: Record<string, string> = {}
) {
  const addArr = Object.keys(addition)
  const len = addArr.length
  for (let i = 0; i < len; i++) {
    addition[addArr[i]] &&
      window._rlog.push(['_addPost', addArr[i], addition[addArr[i]]])
  }
  window._rlog.push(['_trackEvent', eventVal])
  for (let _i = 0; _i < len; _i++) {
    addition[addArr[_i]] && window._rlog.push(['_removePost', addArr[_i]])
  }
}

function ensureDoubleDigits(i: number | string): string {
  if (typeof i === 'number') {
    i = String(i)
  }
  return i.length < 2 ? '0' + i : i
}

export class DateUtil {
  static REGEXP = new RegExp('%\\s*(\\w+)?\\s*%', 'ig')
  static table = {
    YY: (inst: DateUtil) => {
      return ensureDoubleDigits(inst.year)
    },
    MM: (inst: DateUtil) => {
      return ensureDoubleDigits(inst.month)
    },
    DD: (inst: DateUtil) => {
      return ensureDoubleDigits(inst.day)
    },
  }
  static format(date: Date | string, str: string) {
    const inst = new DateUtil(date)
    return inst.format(str)
  }
  static isDate(inst: any) {
    if (inst == null && typeof inst !== 'object') {
      return false
    }
    return Object.getPrototypeOf(inst) === Date.prototype
  }

  date: Date
  year: number
  month: number
  day: number
  constructor(date: Date | string) {
    this.date = DateUtil.isDate(date) ? date as Date : new Date(date)
    this.year = this.date.getFullYear()
    this.month = this.date.getMonth() + 1
    this.day = this.date.getDate()
  }
  isValid() {
    return !!this.day
  }
  format(str: string) {
    if (!this.isValid()) {
      return ''
    }
    return str.replace(DateUtil.REGEXP, (_, $1) => {
      if ((DateUtil.table as any)[$1]) {
        return (DateUtil.table as any)[$1](this) as string
      }
      return _
    })
  }
}


export function isYdCourseApp() {
  return window.navigator.userAgent.toLocaleLowerCase().indexOf('youdaocourse') >= 0;
}

export function isTuringApp() {
  return window.navigator.userAgent.toLocaleLowerCase().indexOf('youdaoturing') >= 0;
}

export function getYdCourseVersion() {
  const reg = /youdaocourse\/(\d*.\d*.\d*)/gi;
  // @ts-ignore
  const [, version] = reg.exec(window.navigator.userAgent);
  return version;
}

/**
 * App版本对比
 * 如果当前APP版本高于目标版本则返回1，低于目标版本则返回-1，相等则返回0
 * @param curVersionStr 当前APP的版本
 * @param targetVersionStr 目标版本
 */
export function compareVersion(curVersionStr: string, targetVersionStr: string): -1|1|0 {
  const curVersion = curVersionStr.split('.')
  const targetVersion = targetVersionStr.split('.')
  const len = Math.max(curVersion.length, targetVersion.length)

  while (curVersion.length < len) {
    curVersion.push('0')
  }
  while (targetVersion.length < len) {
    targetVersion.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(curVersion[i])
    const num2 = parseInt(targetVersion[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }
  return 0;
}

export const isiOS = () => /(iphone|ipad|ipod|ios)/g.test(window.navigator.userAgent.toLowerCase());

/**
 * 判断当前环境是否能够安全使用目标api
 * @param apiName api名称
 */
export function canIUse(apiName: string): boolean {
  if(window.navigator.userAgent.indexOf('youdaoCourse') < 0) return false;
  const curAppVersion = getYdCourseVersion();
  const apiSupportInfo = YD_COURSE_APP_API_SUPPORT_VERSION_LIST[apiName][isiOS()?'ios':'android'];
  return compareVersion(curAppVersion, apiSupportInfo)>=0;
}

export function obj2UrlStr(data: any, url?: string) {
  const search = new URLSearchParams()
  Object.keys(data).forEach(key => {
    search.set(key, String(data[key]))
  })
  return url
    ? url+'?'+search.toString()
    : search.toString()
}

export function escapeHTML(str: string) {
  return str.replace(
    /[&<>'"]/g,
    tag =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[tag] || tag)
  );
}

export function unescapeHTML(str: string) {
  return str.replace(
    /&amp;|&lt;|&gt;|&#39;|&quot;/g,
    tag =>
      ({
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&#39;': "'",
        '&quot;': '"'
      }[tag] || tag)
  );
}
